import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import styles from './SunburstSpinner.module.scss'

/**
 * The `SunburstSpinner`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function SunburstSpinner (props) {
  const { className, isAnimated } = props
  const classNameOutput = useMemo(
    () =>
      classNames([className, styles.spinner, isAnimated && styles.animated]),
    [className, isAnimated]
  )

  return <div className={classNameOutput} />
}

/** @type {object} */
SunburstSpinner.propTypes = {
  className: PropTypes.string,
  isAnimated: PropTypes.bool
}

/** @type {object} */
SunburstSpinner.defaultProps = {
  className: '',
  isAnimated: true
}

// Memoize
export default memo(SunburstSpinner)
